/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */
import 'react-toastify/dist/ReactToastify.css';

import { AuthWrapper } from '@pages/AuthGate/screens/AuthWrapper';
import { AuthenticationContextProvider } from '@src/context/AuthenticationContext';
import { AuthorizationContextProvider } from '@src/context/AuthorizationContext';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { DefaultOptions, QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';

import { AppRouter } from './routes';

const App = () => {
  const { i18n } = useTranslation();

  const queryConfig: DefaultOptions = {
    queries: {
      //To prevent API calling again after failing
      retry: false,
      // To prevent API calling when clicking anywhere in screen
      refetchOnWindowFocus: false,
    },
  };

  const queryClient = new QueryClient({
    defaultOptions: queryConfig,
  });

  return (
    <QueryClientProvider client={queryClient}>
      <AuthenticationContextProvider>
        <AuthorizationContextProvider>
          <AuthWrapper>
            <ToastContainer
              limit={1}
              autoClose={3000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            <Helmet
              titleTemplate="%s | Agency Cockpit - BFI Finance"
              defaultTitle="Agency Cockpit -  BFI Finance"
              htmlAttributes={{ lang: i18n.language }}
            >
              <meta name="description" content="Agency Cockpit application" />
            </Helmet>
            <AppRouter />
          </AuthWrapper>
        </AuthorizationContextProvider>
      </AuthenticationContextProvider>
    </QueryClientProvider>
  );
};

export default App;
